<template>
  <form class="form-horizontal">
    <card>
      <div slot="header">
        <h4 class="card-title">{{ crud }} Grupo de permissão</h4>
      </div>
      <div>
        <fg-input
          name="name"
          label="Nome"
          v-validate="modelValidations.name"
          v-model="name"
          :error="getError('name')"
        ></fg-input>


        <fg-input
         v-if="pass"
          name="custom_permissions"
          label="Permissões">

          <el-select class=""
                      size="large"
                      multiple 
                      style="width: 100%"
                      placeholder="Selecione as permissões"
                      v-model="permission">
            <el-option v-for="option in $store.state.general.listPerm"
                        class=""
                        :value="option.id"
                        :label="option.description"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input
          v-if="showItem"
          name="company"
          label="Empresa">

          <el-select class=""
                      size="large"
                      style="width: 100%"
                      filterable
                      placeholder="Selecione a empresa dos usuários"
                      v-model="company">
            <el-option v-for="option in companyList"
                        class=""
                        :value="option.id"
                        :label="option.name"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
        <fg-input
          v-if="showUser"
          name="users"
          label="Usuários">

          <el-select class=""
                      size="large"
                      multiple
                      style="width: 100%"
                      placeholder="Selecione os usuários"
                      v-model="users">
            <el-option v-for="option in $store.state.general.listUser.user_list_info"
                        class=""
                        :value="option.id"
                        :label="option.username"
                        :key="option.id">
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </card>
    <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>
  </form>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Option.name]: Option,
    [Select.name]: Select
  },
  created() {
    this.$store.dispatch('general/listPerm').then(() => {
      this.pass = true
    })
    if (this.$route.params.id) {
      this.crud = "Editar";
      this.initEdit()
    } else {
      this.crud = "Criar";
    }
  },
  mounted() {
    this.$watch('company', () => {
      this.$store.dispatch('general/ListUser', {id: this.company}).then(() => {
        this.showUser = true
      })
    })
    this.getListCompany()
    if(!this.showItem) {
      this.$store.dispatch('general/listUser').then(() => {
        this.showUser = true
        this.company = this.$store.state.auth.company
        if (this.crud === 'Editar') {
          this.initEdit()
        }
      })
    }
  },
  computed: {
    showItem() {
      const smartmach = localStorage.getItem("smartmach")
      if (smartmach === 'true') {
        return true
      } else {
        return false
      }
    }
  },
  data() {
    return {
      crud: "Editar",
      // imageKey: 0,
      model:{},
      name: '',
      permission: [],
      company: '',
      users: [],
      pass: false,
      modelValidations: {
        name: {
          required: true
        }
      },
      companyList: [],
      showUser: false
    };
  },
  methods: {
    notifySuccess() {
      this.$notify({
        message: "Sucesso</br>Item Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    initEdit () {
      this.$store.dispatch('general/smartmachListUser', {id: this.company}).then(() => {
        this.name = this.$store.state.general.group.name
        this.company = this.$store.state.general.group.company.id
        this.showUser = true
        this.users = this.$store.state.general.group.users
        var x = this.$store.state.general.group.custom_permissions
        this.permission = x.map(v => {
          return v.id
        })
      })
    },
    getListCompany () {
      this.$store.dispatch("company/list").then(resp => {
        this.companyList = resp.sort((a,b) => (a.name > b.name) ? 1 : (b.name > a.name) ? -1 : 0)
    
      })
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.model = {
        name: this.name,
        users: this.users,
        custom_permissions_id: this.permission,
        company_id: this.company,
      }
      this.$validator.validateAll().then(isValid => {
        if (isValid && this.crud === "Criar") {
          this.$store
            .dispatch("general/create", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/permissions`);
            });
        } else if (isValid && this.crud === "Editar") {
          this.model.id = this.$route.params.id 
          this.$store
            .dispatch("general/update", { item: this.model })
            .then(() => {
              this.notifySuccess();
              this.$router.push(`/app/permissions`);
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.el-select {
  margin-bottom: 10px;
}
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
